import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IDeleteActivityUserRequest extends IBaseRequest {
    roleName?:     string;
    role?:         string;
    note?:         string;
    id?:           string;
    userId?:       string;
    activityName?: string;
    acl?:          string;
    activity?:     string;
    isPrimary?:    string;
    contact?:      string;
    userName?:     string;
}

export class DeleteActivityUserRequest extends BaseRequest implements IDeleteActivityUserRequest {

    public roleName?: string;
    public role?: string;
    public note?: string;
    public id?: string;
    public userId?: string;
    public activityName?: string;
    public acl?: string;
    public activity?: string;
    public isPrimary?: string;
    public contact?: string;
    public userName?: string;

  constructor(server: string, session: string, otherOptions:any) {
    super(server, session);
    this.roleName = otherOptions.roleName;
    this.role = otherOptions.role;
    this.note = otherOptions.note;
    this.id = otherOptions.id;
    this.userId = otherOptions.userId;
    this.activityName = otherOptions.activityName;
    this.acl = otherOptions.acl;
    this.activity = otherOptions.activity;
    this.isPrimary = otherOptions.isPrimary;
    this.contact = otherOptions.contact;
    this.userName = otherOptions.userName;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.roleName, 'roleName');
    parameters += this.makeNode(this.role, 'role');
    parameters += this.makeNode(this.note, 'note');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.userId, 'userId');
    parameters += this.makeNode(this.activityName, 'activityName');
    parameters += this.makeNode(this.acl, 'acl');
    parameters += this.makeNode(this.activity, 'activity');
    parameters += this.makeNode(this.isPrimary, 'isPrimary');
    parameters += this.makeNode(this.contact, 'contact');
    parameters += this.makeNode(this.userName, 'userName');

    return super.wrapperXml('DeleteActivityUser', parameters);
  }
}
